import { object, string } from 'yup';

const estateFormSchema = object({
  estate: string().required('Please make a selection.'),
});

export default estateFormSchema;
